export enum StatusEnum {
    new = 'New',
    arbiter = 'arbiter',
    pass = 'pass',
    deny = 'deny'
}


export function checkFn(status: StatusEnum, ev: string = ''): boolean {
    return status.toLowerCase() === ev.toLowerCase();
}
